import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import axios from 'axios';
import InputMask from 'react-input-mask';
import readXlsxFile from 'read-excel-file';
import { toast } from 'react-toastify';
import { Modal, Button, Card, Row, Col, Form, Input, Select, Switch, Alert, Upload, Tooltip, Tag } from 'antd';
import { UserOutlined, TeamOutlined, UploadOutlined, PlusOutlined, CheckOutlined, LoadingOutlined, DownloadOutlined } from '@ant-design/icons';
import Joyride from 'react-joyride';
import validator from 'validator';

import {
  editarCamposContrato,
  obterContratoPeloUsuario,
} from '../actions/ContratoActions';
import { consultarTurmas } from '../actions/TurmaActions';
import { cadastrarAcao } from '../actions/AcaoActions';
import ConfirmationModal from '../components/ConfirmationModal';
import {
  deletarFormando,
  obterFormandosPeloContrato,
  adicionarFormando,
  editarFormando,
  editarFormandoEUsuario,
  adicionarFormandoECriarUsuario,
} from '../actions/FormandoActions';
import {
  adicionarItemFormando,
  removerItemFormando,
} from '../actions/ItemFormandoActions';
import EmailService from '../services/EmailService';
import TabelaFormandos from '../components/TabelaFormandos';
import ModalPagamento from '../components/ModalPagamento';
import { Modal as BSModal } from 'react-bootstrap';
import { REQUEST_URL, URL_PAGAMENTO } from '../config/urls';


class Formandos extends React.Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
  }

  state = {
    contratos: [],
    iniciar: true,
    inputFile: null,
    formandoSelecionado: null,
    showModalFormando: false,
    showModalNotificacao: false,
    showModalCursoNaoCadastrado: false,
    operacao: 'adicionar',
    botaoFinalizar: false,
    formando: {
      nome: '',
      email: '',
      celular: '',
      documento: "",
      dataNascimento: "",
      contrato: 0,
      turma: null,
      membroComissao: false,
      usuario: 0,
    },
    formandos: [],
    cursoSelecionadoPlanilha: [],
    botaoCadastrarFormandosPorPlanilha: false,
    turmasSelect: [],
    rateioDraft: {},
    pedidosContrato: [],
    pedidosCarregados: false,
    showModalPagamentoDiferenca: false,
    dadosPagamentoDiferenca: null,
    formandoPagadorDiferenca: null,
    abrindoPagamento: false,
    run: false,
    steps: [
      {
        content: (
          <div>
            <h3>Bem-vindo(a) a página de cadastro dos formandos!</h3>{' '}
            <span style={{ textAlign: 'center' }}>
              É aqui que você conseguirá gerenciar as informações dos formandos.
            </span>
          </div>
        ),
        placement: 'center',
        target: '#divContent',
      },
      {
        content: (
          <div>
            <h3>Cadastrar formandos pela planilha</h3>{' '}
            <span style={{ textAlign: 'center' }}>
              Você pode adicionar vários formandos de uma vez clicando aqui.
            </span>
          </div>
        ),
        placement: 'bottom',
        target: '#formandoPlanilha',
      },
      {
        content: (
          <div>
            <h3>Cadastrar formandos manualmente</h3>{' '}
            <span style={{ textAlign: 'center' }}>
              Você também pode adicioná-los de forma manual clicando aqui.
            </span>
          </div>
        ),
        placement: 'bottom',
        target: '#formandoManual',
      },
      {
        content: (
          <div>
            <h3>Finalização da etapa</h3>{' '}
            <span style={{ textAlign: 'center' }}>
              Após adição de todos os formandos, finalize a etapa clicando neste
              botão!
            </span>
          </div>
        ),
        target: '#btnFinalizarEtapa',
      },
    ],
  };

  async componentDidMount() {
    this._isMounted = true;
    if (this.props.usuario_a.tipo === 'comissao') {
      await this.iniciar();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  async iniciar() {
    try {
      await this.props.obterContratoPeloUsuario(this.props.usuario_a.id);

      if (!this._isMounted) return;

      if (this.props.contrato && this.props.contrato.id) {
        await this.props.obterFormandosPeloContrato(this.props.contrato.id);
        await this.carregarPedidosContrato();
      }

      if (this.props.contrato) {
        let turmas = [],
          formandos = [];
        if (
          this.props.contrato.turmas &&
          this.props.contrato.turmas.length > 0
        ) {
          if (this.props.contrato.cadastrouFormandos === 0) {
            this.setState({ run: true });
          }
          this.props.contrato.turmas.forEach((turma) => {
            turmas.push({ value: turma.id, label: turma.curso });
            turma.formandos.forEach((formando) => {
              formandos.push({
                id: formando.id,
                nome: formando.nome,
                email: formando.email,
                celular: formando.celular,
                documento: formando.documento,
                dataNascimento: formando.dataNascimento,
                turma: turma.id,
                curso: turma.curso,
                usuario: formando.usuario,
                membroComissao: formando.membroComissao,
              });
            });
          });
          formandos.sort((a, b) => {
            return a.nome.toLowerCase() > b.nome.toLowerCase() ? 1 : -1;
          });
          if (this._isMounted) {
            this.setState({ turmasSelect: turmas, formandos });
          }
        } else {
          if (this._isMounted) {
            this.setState({ showModalCursoNaoCadastrado: true });
          }
        }
      }
      if (this._isMounted) {
        this.setState({ iniciar: false });
      }
    } catch (error) {
      console.error('Erro ao iniciar formandos:', error);
      if (this._isMounted) {
        this.setState({ iniciar: false });
      }
    }
  }

  async finalizar() {
    if (this.temExcedentePendente()) {
      toast.warning("Pague a diferença do excedente antes de concluir o cadastro.");
      this.setState({ showModalFinalizar: false });
      return;
    }
    if (this.temDistribuicaoPendente()) {
      const pendentes = this.itensPendentesDistribuicao();
      toast.warning(`Distribua todos os itens contratados antes de concluir. Faltam: ${pendentes.map(p => `${p.restante} de ${p.nome}`).join(', ')}.`);
      this.setState({ showModalFinalizar: false });
      return;
    }
    let email = new EmailService(),
      data = { cadastrouFormandos: 1, confirmarPlanilha: 1 };
    this.setState({ botaoFinalizar: true });

    // Aguardar a atualização do contrato
    await this.props.editarCamposContrato(this.props.contrato.id, data);

    // Recarregar o contrato atualizado
    await this.props.obterContratoPeloUsuario(this.props.contrato.usuario.id);

    //cadastrar notificação para admistração
    let acao = {
      ator: this.props.contrato.dono.id,
      texto: `Comissão confirmou o cadastro de formandos para o contrato ${this.props.contrato.numero}`,
      data: new Date(),
      contrato: this.props.contrato.id,
      tipo: 'comissao',
      visualizado: false,
    };
    email.enviar('updateAcaoComissaoToDesigner', {
      numero: this.props.contrato.numero,
      mensagem: 'o cadastro de formandos',
      designer: { email: this.props.contrato.dono.email },
    });
    this.props.cadastrarAcao(acao);
    this.setState({ botaoFinalizar: false, showModalNotificacao: true, showModalFinalizar: false });
  }

  async salvar(event) {
    event.preventDefault();
    let formando = this.state.formando;

    formando.turma = formando.turma.value;
    formando.celular = Number(
      String(formando.celular).replace(/[()-.+\s]/g, '')
    );

    if (formando.turma) {
      if (validator.isEmail(formando.email)) {
        if (this.state.operacao === 'adicionar') {
          formando.contrato = this.props.contrato.id;
          formando.continuarDepois = false;
          if (
            !this.props.contrato.contratante.includes('Alpha-e') &&
            this.props.contrato.sistemaPagto === 1
          ) {
            this.props.adicionarFormandoECriarUsuario(formando).then(() => {
              toast.success('Formando cadastrado com sucesso!');
              let acao = {
                ator: this.props.contrato.dono.id,
                texto: `O formando ${formando.nome} foi adicionando no contrato ${this.props.contrato.numero} e o usuário foi gerado automaticamente.`,
                data: new Date(),
                contrato: this.props.contrato.id,
                tipo: 'atrasado',
                visualizado: false,
              };
              this.props.cadastrarAcao(acao);
              this.resetar();
              this.iniciar();
            });
          } else {
            delete formando.usuario;
            this.props.adicionarFormando(formando).then(() => {
              toast.success('Formando cadastrado com sucesso!');
              let acao = {
                ator: this.props.contrato.dono.id,
                texto: `O formando ${formando.nome} foi adicionando no contrato ${this.props.contrato.numero}.`,
                data: new Date(),
                contrato: this.props.contrato.id,
                tipo: 'atrasado',
                visualizado: false,
              };
              this.props.cadastrarAcao(acao);
              this.resetar();
              this.iniciar();
            });
          }
        } else {
          if (formando.usuario) {
            await this.props.editarFormandoEUsuario(formando);
          } else {
            delete formando.usuario;
            await this.props.editarFormando(formando);
          }
          await this.resetar();
          await this.iniciar();
          toast.success('Formando alterado com sucesso!');
        }
      } else {
        toast.info(`Informe um e-mail válido!`);
      }
    } else {
      toast.info(`Selecione um curso!`);
    }
  }

  async resetar() {
    this.setState({
      showModalFormando: false,
      operacao: "adicionar",
      formandoSelecionado: null,
      formando: {
        nome: "",
        email: "",
        celular: "",
        documento: "",
        dataNascimento: "",
        turma: {},
        usuario: 0
      }
    });
  }

  async deletar() {
    await this.props.deletarFormando(this.state.formandoSelecionado);
    await this.resetar();
    await this.iniciar();
  }

  handleClickEditar = (formando) => {
    formando = {
      id: formando.id,
      nome: formando.nome,
      email: formando.email,
      celular: formando.celular,
      documento: formando.documento || "",
      dataNascimento: formando.dataNascimento || "",
      contrato: this.props.contrato.id,
      usuario: formando.usuario,
      membroComissao: formando.membroComissao,
      turma: {
        value: formando.turma,
        label: formando.curso,
      },
    };
    this.setState({ operacao: 'editar', formando, showModalFormando: true });
  };

  handleClickDelete = (id) => {
    this.setState({ formandoSelecionado: id });
    this.refs.modal.open();
  };

  async carregarListaFormandos() {
    const selectedFile = this.state.selectedFile;

    if (!selectedFile) {
      toast.error("Insira a planilha preenchida com as informações dos formandos!");
      return;
    }

    if (!this.state.cursoSelecionadoPlanilha || !this.state.cursoSelecionadoPlanilha.value) {
      toast.error("Selecione o curso que os formandos pertencem!");
      return;
    }

    this.setState({ botaoCadastrarFormandosPorPlanilha: true });
    let erroAoCadastrarFormandos = false;
    let formandosAdicionados = 0;

    try {
      const cols = await readXlsxFile(selectedFile);

      if (!cols || cols.length <= 1) {
        toast.error("A planilha está vazia ou não contém dados válidos!");
        return;
      }

      const comSistemaPagto = !this.props.contrato.contratante.includes("Alpha-e") && this.props.contrato.sistemaPagto === 1;

      for (let i = 1; i < cols.length; i++) {
        const col = cols[i];

        // 0: Nome, 1: E-mail, 2: Celular, 3: Membro da Comissão (sim/não), 4: CPF, 5: Data de Nascimento
        if (col[0] == null || col[1] == null || col[2] == null || col[3] == null || col[4] == null) {
          toast.error(`Erro na linha ${i + 1}: campos obrigatórios faltando!`);
          erroAoCadastrarFormandos = true;
          continue;
        }

        if (!validator.isEmail(String(col[1]))) {
          toast.error(`Erro na linha ${i + 1} (${col[0]}): e-mail inválido!`);
          erroAoCadastrarFormandos = true;
          continue;
        }

        const formando = {
          nome: col[0],
          email: String(col[1]),
          celular: Number(String(col[2]).replace(/[()-.+\s]/g, "")),
          membroComissao: String(col[3]).toLowerCase().includes("s") ? 1 : 0,
          documento: String(col[4]).replace(/[.-]/g, ""),
          dataNascimento: col[5] || "",
          turma: this.state.cursoSelecionadoPlanilha.value,
          contrato: this.props.contrato.id,
          continuarDepois: true
        };

        try {
          if (comSistemaPagto) {
            // Cria usuário primeiro, depois formando — em série via axios direto
            const usuarioResp = await axios.post(`${REQUEST_URL}/usuarios`, {
              login: formando.email,
              senha: Math.random().toString(36).slice(-8),
              nome: formando.nome,
              tipo: 'formando',
              email: formando.email
            });
            formando.usuario = usuarioResp.data.id;
            await axios.post(`${REQUEST_URL}/formandos`, formando);
          } else {
            await axios.post(`${REQUEST_URL}/formandos`, formando);
          }
          formandosAdicionados++;
        } catch (error) {
          toast.error(`Erro ao adicionar ${col[0]}: ${error.response?.data?.error || error.message || 'Erro desconhecido'}`);
          erroAoCadastrarFormandos = true;
        }
      }

      await this.iniciar();

      if (erroAoCadastrarFormandos && formandosAdicionados > 0) {
        toast.info(`${formandosAdicionados} formando(s) cadastrado(s). Alguns não puderam ser cadastrados.`);
      } else if (formandosAdicionados > 0) {
        toast.success(`${formandosAdicionados} formando(s) cadastrado(s) com sucesso!`);
      } else if (!erroAoCadastrarFormandos) {
        toast.warning("Nenhum formando foi cadastrado.");
      }

    } catch (error) {
      toast.error("Erro ao processar a planilha. Verifique se o arquivo está no formato correto.");
      console.error("Erro ao ler planilha:", error);
    } finally {
      const uploadInput = document.querySelector("#upload");
      if (uploadInput) uploadInput.value = "";
      const fakeInput = document.querySelector("#fakeInput");
      if (fakeInput) fakeInput.value = "";
      this.setState({ botaoCadastrarFormandosPorPlanilha: false, cursoSelecionadoPlanilha: [], selectedFile: null, fileName: '' });
    }
  } handleChangeCurso(turmaSelecionada) {
    this.setState({
      formando: { ...this.state.formando, turma: turmaSelecionada },
    });
  }

  handleChangeMembroComissao() {
    this.setState({
      formando: {
        ...this.state.formando,
        membroComissao: !this.state.formando.membroComissao,
      },
    });
  }

  handleChangeCursoSelecionadoPlanilha(cursoSelecionadoPlanilha) {
    this.setState({ cursoSelecionadoPlanilha });
  }

  handleChangeFormando = (e) => {
    const { name, value } = e.target;

    this.setState({ formando: { ...this.state.formando, [name]: value } });
  };

  handleClickReenviarEmail = async (formando) => {
    await axios
      .get(`${REQUEST_URL}/formandos/${formando.usuario}/pegar-usuario`)
      .then((response) => {
        new EmailService().enviar('formando', {
          usuario: { ...response.data[0] },
        });
        toast.success('E-mail enviado com sucesso!');
      })
      .catch((err) => {
        toast.error('Este usuário não possui acesso ao sistema!');
      });
  };

  uploadSpreadsheet() {
    const file = document.querySelector('#upload');
    if (file) {
      file.click();
    }
  }

  handleFileChange = (e) => {
    const file = e.target;
    const fakeInput = document.querySelector('#fakeInput');
    if (fakeInput && file.value) {
      fakeInput.value = file.value.replace(/C:\\fakepath\\/i, '');
    }
    if (e.target.files && e.target.files[0]) {
      this.setState({ selectedFile: e.target.files[0] });
    }
  }

  // ===== Rateio (pagamentoIndividual = false) =====

  ehRateioAtivo() {
    return this.props.contrato
      && String(this.props.contrato.pagamentoIndividual) === "false";
  }

  rateioBloqueado() {
    // Bloqueia novas compras de excedente quando a etapa de cadastro foi concluída
    return this.props.contrato && this.props.contrato.cadastrouFormandos === 1;
  }

  // Há excedente não pago? Usado para bloquear a conclusão do cadastro.
  temExcedentePendente() {
    if (!this.ehRateioAtivo()) return false;
    const { totais } = this.getResumoRateio();
    return totais.excedente > 0 && totais.valorDiferenca > 0;
  }

  // Há itens contratados ainda não distribuídos? Bloqueia a conclusão do cadastro.
  temDistribuicaoPendente() {
    if (!this.ehRateioAtivo()) return false;
    const { porItem } = this.getResumoRateio();
    return porItem.some((r) => r.contratada > 0 && r.distribuida < r.contratada);
  }

  itensPendentesDistribuicao() {
    if (!this.ehRateioAtivo()) return [];
    const { porItem } = this.getResumoRateio();
    return porItem
      .filter((r) => r.contratada > 0 && r.distribuida < r.contratada)
      .map((r) => ({
        nome: (r.item && r.item.nome) || 'Item',
        contratada: r.contratada,
        distribuida: r.distribuida,
        restante: r.contratada - r.distribuida,
      }));
  }

  async carregarPedidosContrato() {
    if (!this.ehRateioAtivo()) {
      this.setState({ pedidosContrato: [], pedidosCarregados: true });
      return;
    }
    try {
      const token = sessionStorage.getItem("tokenPagamento");
      if (!token) {
        this.setState({ pedidosContrato: [], pedidosCarregados: true });
        return;
      }
      const response = await axios.get(`${URL_PAGAMENTO}/pedidos-contrato`, {
        headers: { Authorization: "Bearer " + token },
      });
      if (this._isMounted) {
        this.setState({ pedidosContrato: response.data || [], pedidosCarregados: true });
      }
    } catch (e) {
      // Sem pedidos é cenário válido (nada foi pago ainda)
      if (this._isMounted) {
        this.setState({ pedidosContrato: [], pedidosCarregados: true });
      }
    }
  }

  // Soma quantidades já pagas (pedidos não cancelados) por item do contrato
  getQuantidadesJaPagas() {
    const map = {};
    const pedidosContrato = this.state.pedidosContrato || [];
    pedidosContrato.forEach((formando) => {
      (formando.pedidos || []).forEach((pedido) => {
        if (pedido.status === "Pedido cancelado") return;
        (pedido.itens || []).forEach((itemPedido) => {
          const id = Number(itemPedido.itemContrato);
          if (!Number.isFinite(id)) return;
          map[id] = (map[id] || 0) + Number(itemPedido.quantidade || 0);
        });
      });
    });
    return map;
  }

  // Soma quantidades de um item específico já vinculadas a pedidos (não cancelados)
  // de um formando específico. Usado para evitar reduzir a quantidade contratada
  // abaixo do que já está em pedidos (o que dispara FK no banco).
  getQuantidadeEmPedidos(formandoId, itemId) {
    const pedidosContrato = this.state.pedidosContrato || [];
    const registro = pedidosContrato.find((f) => f.id === formandoId);
    if (!registro) return 0;
    let total = 0;
    (registro.pedidos || []).forEach((pedido) => {
      if (pedido.status === "Pedido cancelado") return;
      (pedido.itens || []).forEach((itemPedido) => {
        if (Number(itemPedido.itemContrato) === Number(itemId)) {
          total += Number(itemPedido.quantidade || 0);
        }
      });
    });
    return total;
  }

  itensRateaveis() {
    const itens = (this.props.contrato && this.props.contrato.itens) || [];
    return itens.filter((i) => i.observacao !== "brinde");
  }

  getQuantidadeRateio(formandoId, itemId) {
    const formando = (this.props.formandosComItens || []).find((f) => f.id === formandoId);
    if (!formando || !formando.itens) return { id: null, quantidade: 0 };
    const reg = formando.itens.find((it) => it.item === itemId && it.tipo === "contratado");
    return reg ? { id: reg.id, quantidade: Number(reg.quantidade) || 0 } : { id: null, quantidade: 0 };
  }

  handleChangeRateio = (formandoId, item, valor) => {
    const rateioDraft = { ...(this.state.rateioDraft || {}) };
    const key = `${formandoId}_${item.id}`;
    let n = parseInt(valor, 10);
    if (!Number.isFinite(n) || n < 0) n = 0;
    rateioDraft[key] = n;
    this.setState({ rateioDraft });
  };

  handleBlurRateio = async (formandoId, item) => {
    const rateioDraft = { ...(this.state.rateioDraft || {}) };
    const key = `${formandoId}_${item.id}`;
    if (!(key in rateioDraft)) return;

    const novaQtd = rateioDraft[key];
    const atual = this.getQuantidadeRateio(formandoId, item.id);

    if (novaQtd === atual.quantidade) {
      delete rateioDraft[key];
      this.setState({ rateioDraft });
      return;
    }

    const qtdEmPedidos = this.getQuantidadeEmPedidos(formandoId, item.id);
    if (novaQtd < qtdEmPedidos) {
      toast.error(
        `Não é possível reduzir para ${novaQtd}: este formando já tem ${qtdEmPedidos} unidade(s) de "${item.nome || 'este item'}" vinculada(s) a pedidos. Cancele os pedidos relacionados antes de diminuir a quantidade.`,
        { autoClose: 8000 }
      );
      delete rateioDraft[key];
      this.setState({ rateioDraft });
      return;
    }

    try {
      if (novaQtd === 0 && atual.id) {
        await this.props.removerItemFormando(atual.id);
      } else if (novaQtd > 0) {
        const payload = {
          formando: formandoId,
          item: item.id,
          quantidade: novaQtd,
          preco: Number(item.preco) || 0,
          tipo: "contratado",
        };
        if (atual.id) payload.id = atual.id;
        await this.props.adicionarItemFormando(payload);
      }
      await this.props.obterFormandosPeloContrato(this.props.contrato.id);
    } catch (e) {
      toast.error("Não foi possível salvar a distribuição. Tente novamente.");
    }

    delete rateioDraft[key];
    this.setState({ rateioDraft });
  };

  valorRateioInput(formandoId, itemId) {
    const rateioDraft = this.state.rateioDraft || {};
    const key = `${formandoId}_${itemId}`;
    if (key in rateioDraft) return rateioDraft[key];
    return this.getQuantidadeRateio(formandoId, itemId).quantidade;
  }

  getResumoRateio() {
    const itens = this.itensRateaveis();
    const formandos = this.props.formandosComItens || [];
    const jaPagasMap = this.getQuantidadesJaPagas();

    const porItem = itens.map((item) => {
      let contratada = Number(item.quantidade) || 0,
        distribuida = 0;
      formandos.forEach((f) => {
        distribuida += this.getQuantidadeRateio(f.id, item.id).quantidade;
      });
      const jaPaga = Number(jaPagasMap[item.id] || 0);
      // Capacidade efetiva = quantidade contratada + o que já foi pago como excedente
      const capacidadeEfetiva = contratada + jaPaga;
      // Restante = o que ainda falta distribuir para cobrir a quantidade
      // contratada. Baseia-se na contratada (não na capacidadeEfetiva) para não
      // mostrar pendência quando a lista já está fechada após pagar excedente.
      const restante = Math.max(0, contratada - distribuida);
      const excedente = Math.max(0, distribuida - capacidadeEfetiva);
      const preco = Number(item.preco) || 0;
      const valorDiferenca = excedente * preco;

      let status;
      if (excedente > 0) {
        status = "Excedente com diferença a pagar";
      } else if (contratada > 0 && distribuida >= contratada) {
        // Fecha quando a distribuição cobre a quantidade contratada e não há
        // excedente a pagar. Não exigimos igualdade com capacidadeEfetiva: se a
        // comissão pagou um excedente (jaPaga > 0) e depois reduziu a
        // distribuição de volta para a contratada, a lista continua fechada.
        status = jaPaga > 0 ? "Lista fechada (diferença paga)" : "Lista fechada";
      } else {
        status = "Distribuição pendente";
      }

      return { item, contratada, capacidadeEfetiva, jaPaga, distribuida, restante, excedente, preco, valorDiferenca, status };
    });

    const totais = porItem.reduce((a, r) => ({
      contratada: a.contratada + r.contratada,
      distribuida: a.distribuida + r.distribuida,
      restante: a.restante + r.restante,
      excedente: a.excedente + r.excedente,
      valorDiferenca: a.valorDiferenca + r.valorDiferenca,
      jaPaga: a.jaPaga + r.jaPaga,
    }), { contratada: 0, distribuida: 0, restante: 0, excedente: 0, valorDiferenca: 0, jaPaga: 0 });

    // Lista geral fecha quando todo item contratado está coberto pela
    // distribuição e não há excedente pendente. Deriva de porItem (que já trata
    // o caso de jaPaga > 0) em vez de totais.restante, que fica inflado pela
    // capacidadeEfetiva quando houve pagamento de excedente.
    const temItemContratado = porItem.some((r) => r.contratada > 0);
    const algumPendente = porItem.some((r) => r.contratada > 0 && r.distribuida < r.contratada);
    let statusGeral = "Distribuição pendente";
    if (totais.excedente > 0) statusGeral = "Excedente com diferença a pagar";
    else if (temItemContratado && !algumPendente) {
      statusGeral = totais.jaPaga > 0 ? "Lista fechada (diferença paga)" : "Lista fechada";
    }

    return { porItem, totais, statusGeral };
  }

  formatarMoedaBR(valor) {
    const n = Number(valor);
    if (!Number.isFinite(n) || n === 0) return '0,00';
    const partes = n.toFixed(2).split('.');
    partes[0] = partes[0].split(/(?=(?:...)*$)/).join('.');
    return partes.join(',');
  }

  // Pagador da diferença = sempre o acesso da comissão (usuário logado).
  // Busca o registro de formando vinculado ao usuário logado. Se a comissão não
  // tiver um registro próprio de formando, faz fallback para o primeiro membro
  // da comissão e, por último, o primeiro formando — para nunca travar a cobrança.
  getFormandoPagador() {
    const formandos = this.props.formandosComItens || [];
    const usuarioId = this.props.usuario_a && this.props.usuario_a.id;
    const proprio = formandos.find((f) => Number(f.usuario) === Number(usuarioId));
    if (proprio) return proprio;
    const membro = formandos.find((f) => f.membroComissao);
    if (membro) return membro;
    return formandos[0] || null;
  }

  // Distribui o excedente de um item entre os formandos proporcionalmente ao que
  // cada um tem distribuído daquele item no rateio (itens_formando tipo
  // 'contratado'). Espelha exatamente distribuirItemRateio do
  // TabelaItensContratados para que o que aparece no checkout seja o mesmo que
  // será redistribuído depois — "mostrar certo = distribuir certo".
  distribuirExcedentePorFormando(item, excedente) {
    const formandos = this.props.formandosComItens || [];
    if (excedente <= 0) return [];

    let somaDistribuida = 0;
    const base = formandos.map((f) => {
      const qtd = this.getQuantidadeRateio(f.id, item.id).quantidade;
      somaDistribuida += qtd;
      return { formando: f, qtd };
    });
    if (somaDistribuida <= 0) return [];

    let restante = excedente;
    const partes = base.map(({ formando, qtd }) => {
      const fracao = qtd > 0 ? Math.floor((qtd * excedente) / somaDistribuida) : 0;
      restante -= fracao;
      return { formando, qtdRateio: qtd, quantidade: fracao };
    });
    // Sobra do arredondamento: 1 a 1 nos formandos com maior rateio.
    if (restante > 0) {
      const ordenados = partes
        .map((p, i) => ({ i, qtdRateio: p.qtdRateio }))
        .filter((p) => p.qtdRateio > 0)
        .sort((a, b) => b.qtdRateio - a.qtdRateio);
      for (let k = 0; k < ordenados.length && restante > 0; k++) {
        partes[ordenados[k].i].quantidade += 1;
        restante -= 1;
      }
    }
    return partes.filter((p) => p.quantidade > 0);
  }

  // Abre direto o pagamento da diferença no nome do usuário logado (acesso da
  // comissão), sem etapa de seleção de pagador.
  abrirSelecaoPagador = () => {
    if (this.rateioBloqueado()) {
      toast.info("Cadastro de formandos concluído. Não é possível pagar excedentes nesta etapa.");
      return;
    }
    const { totais } = this.getResumoRateio();
    if (totais.excedente <= 0 || totais.valorDiferenca <= 0) {
      toast.info("Não há diferença para pagar.");
      return;
    }

    const pagador = this.getFormandoPagador();
    if (!pagador) {
      toast.error("Cadastre ao menos um formando antes de pagar a diferença.");
      return;
    }

    const { porItem } = this.getResumoRateio();
    const itensExcedentes = porItem.filter((r) => r.excedente > 0);

    if (itensExcedentes.length === 0) {
      toast.info("Nenhum item excedente encontrado.");
      return;
    }

    // 1) Itens AGREGADOS para a cobrança (o que o backend grava). Prefixo
    //    [RATEIO] marca o pedido para redistribuição entre os formandos depois.
    //    Para kits, a quantidade já está em "unidades de kit" (item.quantidade
    //    do contrato é em kits), então basta enviar como está.
    const itensCobranca = itensExcedentes.map((r) => ({
      idProduto: r.item.id,
      produto: `[RATEIO] ${r.item.produto}`,
      quantidade: r.excedente,
      preco: r.preco,
      total: r.valorDiferenca,
    }));

    // 2) Linhas DETALHADAS por formando, apenas para EXIBIÇÃO no checkout —
    //    cada formando aparece com a sua parte do excedente. A distribuição usa
    //    a mesma regra proporcional aplicada depois em TabelaItensContratados.
    const linhasPorFormando = [];
    itensExcedentes.forEach((r) => {
      const partes = this.distribuirExcedentePorFormando(r.item, r.excedente);
      partes.forEach(({ formando, quantidade }) => {
        let linha = linhasPorFormando.find((l) => l.id === formando.id);
        if (!linha) {
          linha = { id: formando.id, nome: formando.nome, itens: [] };
          linhasPorFormando.push(linha);
        }
        linha.itens.push({
          idProduto: r.item.id,
          produto: `[RATEIO] ${r.item.produto}`,
          quantidade,
          preco: r.preco,
          total: quantidade * r.preco,
        });
      });
    });

    // Fallback: se não houve distribuição proporcional (ex.: rateio zerado),
    // exibe os itens agregados no nome do pagador para não mostrar tela vazia.
    const dadosExibicao = linhasPorFormando.length > 0
      ? linhasPorFormando
      : [{ id: pagador.id, nome: pagador.nome, itens: itensCobranca }];

    const data = [{
      id: pagador.id,
      nome: pagador.nome,
      itens: itensCobranca,
      // Consumido pelo ModalPagamento só para renderizar a confirmação por
      // formando, sem afetar o payload de cobrança (que usa `itens`).
      linhasExibicao: dadosExibicao,
    }];

    // Abre o pagamento direto no nome do pagador (acesso da comissão).
    this.setState({
      showModalPagamentoDiferenca: true,
      dadosPagamentoDiferenca: data,
      formandoPagadorDiferenca: pagador,
      abrindoPagamento: false,
    });
  };

  fecharModalPagamentoDiferenca = async (response) => {
    if (response && response.status === 201) {
      toast.success("Pagamento da diferença iniciado com sucesso!");
      // Refetch pedidos para a próxima abertura mostrar excedente já descontado
      await this.carregarPedidosContrato();
    } else if (response && response.status === 500) {
      toast.error("Não foi possível processar o pagamento. Tente novamente.");
    }
    setTimeout(() => {
      if (!this._isMounted) return;
      this.setState({
        showModalPagamentoDiferenca: false,
        dadosPagamentoDiferenca: null,
        formandoPagadorDiferenca: null,
      });
    }, 150);
  };

  _renderResumoRateio() {
    if (!this.ehRateioAtivo()) return null;
    const { totais, statusGeral } = this.getResumoRateio();
    const fechada = statusGeral.startsWith("Lista fechada");
    const corStatus = fechada ? "#16a34a"
      : statusGeral === "Excedente com diferença a pagar" ? "#b91c1c"
      : "#b45309";
    const bgStatus = fechada ? "#f0fdf4"
      : statusGeral === "Excedente com diferença a pagar" ? "#fef2f2"
      : "#fffbeb";

    const temDiferenca = totais.excedente > 0 && totais.valorDiferenca > 0;
    const bloqueado = this.rateioBloqueado();

    const kpis = [
      { label: "Contratado", valor: totais.contratada, cor: "#0f172a" },
      { label: "Distribuído", valor: totais.distribuida, cor: "#0f172a" },
      { label: "Restante", valor: totais.restante, cor: "#b45309" },
      // Itens já comprados/pagos além do contratado (excedente quitado).
      ...(totais.jaPaga > 0 ? [{ label: "Já paga", valor: totais.jaPaga, cor: "#0369a1" }] : []),
      { label: "Excedente", valor: totais.excedente, cor: "#b91c1c" },
      { label: "Diferença", valor: `R$ ${this.formatarMoedaBR(totais.valorDiferenca)}`, cor: "#b91c1c" },
    ];

    return (
      <div style={{
        marginTop: 14,
        padding: "10px 16px",
        background: "#f8fafc",
        border: "1px solid #e5e7eb",
        borderRadius: 10,
      }}>
        <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 16, rowGap: 8 }}>
          {kpis.map((c, i) => (
            <div key={i} style={{ display: "flex", alignItems: "baseline", gap: 6 }}>
              <span style={{ fontSize: 10.5, fontWeight: 700, color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.03em" }}>{c.label}</span>
              <span style={{ fontSize: 15, fontWeight: 700, color: c.cor }}>{c.valor}</span>
            </div>
          ))}

          <span style={{
            background: bgStatus, color: corStatus,
            padding: "3px 12px", borderRadius: 12, fontSize: 11.5, fontWeight: 700,
          }}>{statusGeral}</span>

          <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 10 }}>
            {temDiferenca && !bloqueado ? (
              <Button
                type="primary"
                danger
                size="small"
                loading={this.state.abrindoPagamento}
                icon={!this.state.abrindoPagamento ? <i className="fa fa-credit-card" style={{ marginRight: 6 }} /> : null}
                onClick={this.abrirSelecaoPagador}
                style={{ fontWeight: 600 }}
              >
                Pagar diferença
              </Button>
            ) : null}
            {temDiferenca && bloqueado ? (
              <Tag color="default" style={{ fontWeight: 600 }}>Etapa concluída - excedente bloqueado</Tag>
            ) : null}
          </div>
        </div>

        {totais.excedente > 0 && !bloqueado ? (
          <div style={{ marginTop: 8, fontSize: 12, color: "#92400e", display: "flex", alignItems: "center", gap: 6 }}>
            <i className="fa fa-exclamation-triangle" style={{ color: "#f59e0b" }}></i>
            A quantidade distribuída ultrapassa a contratada. Será necessário cobrar a diferença para fechar a lista.
          </div>
        ) : null}
      </div>
    );
  }

  _renderModalPagamentoDiferenca() {
    const show = this.state.showModalPagamentoDiferenca
      && !!this.state.dadosPagamentoDiferenca
      && !!this.state.formandoPagadorDiferenca;

    return (
      <BSModal
        show={show}
        onHide={() => setTimeout(() => this.fecharModalPagamentoDiferenca(), 150)}
        id="modalPagamento"
        animation={false}
      >
        {show ? (
          <ModalPagamento
            contrato={this.props.contrato}
            data={this.state.dadosPagamentoDiferenca}
            formando={this.state.formandoPagadorDiferenca}
            formatarMoedaBR={this.formatarMoedaBR.bind(this)}
            close={(response) => this.fecharModalPagamentoDiferenca(response)}
            usuarioLogado={this.props.usuario_a}
            exigirDadosTitular={true}
          />
        ) : null}
      </BSModal>
    );
  }

  // Barra compacta de indicadores (substitui os cards grandes do topo).
  // Informações auxiliares, altura baixa, sem ocupar metade da tela.
  _renderBarraIndicadores() {
    const numUsuarios = this.state.formandos.length;
    const numUsuariosComAcesso = this.state.formandos.filter((f) => f.usuario).length;
    const concluido = this.props.contrato.cadastrouFormandos === 1;

    const item = (icone, label, valor, corValor) => (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
        <span style={{ color: '#9ca3af', fontSize: 14, display: 'flex' }}>{icone}</span>
        <span style={{ color: '#6b7280', fontSize: 12.5 }}>{label}:</span>
        <span style={{ color: corValor || '#212121', fontSize: 13.5, fontWeight: 700 }}>{valor}</span>
      </div>
    );

    const separador = <span style={{ width: 1, height: 22, background: '#e5e7eb' }} />;

    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 16,
        rowGap: 8,
        padding: '10px 16px',
        background: '#fff',
        border: '1px solid #e5e7eb',
        borderRadius: 10,
        marginBottom: 16,
        minHeight: 52,
      }}>
        {item(<UserOutlined />, 'Formandos', `${numUsuariosComAcesso}/${numUsuarios}`)}
        {separador}
        {item(<CheckOutlined />, 'Com acesso', numUsuariosComAcesso, '#16a34a')}
        {separador}
        {item(<TeamOutlined />, 'Turmas', this.state.turmasSelect.length)}
        <Button
          type="link"
          size="small"
          onClick={() => this.setState({ showModalTurmas: true })}
          style={{ padding: 0, height: 'auto', color: '#d32f2f', fontWeight: 600, fontSize: 12.5 }}
        >
          Visualizar turmas
        </Button>
        {separador}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ color: '#6b7280', fontSize: 12.5 }}>Status:</span>
          <span style={{
            background: concluido ? '#f0fdf4' : '#fffbeb',
            color: concluido ? '#16a34a' : '#b45309',
            padding: '2px 12px',
            borderRadius: 12,
            fontSize: 11.5,
            fontWeight: 700,
          }}>
            {concluido ? 'Cadastro concluído' : 'Cadastro em andamento'}
          </span>
        </div>
      </div>
    );
  }

  // Botão "Concluir Cadastro" — renderizado abaixo da tabela. Mostra a tag de
  // etapa concluída quando já finalizado, ou o botão (com bloqueio/tooltip
  // quando há excedente ou distribuição pendente).
  _renderBotaoConcluir() {
    const primaryColor = '#d32f2f';

    if (this.props.contrato.cadastrouFormandos === 1) {
      return (
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
          <Tag color="success" style={{ padding: '6px 16px', fontSize: '14px', borderRadius: '4px' }}>
            <CheckOutlined /> Etapa Concluída
          </Tag>
        </div>
      );
    }

    const excedentePendente = this.temExcedentePendente();
    const distribuicaoPendente = this.temDistribuicaoPendente();
    const bloqueado = excedentePendente || distribuicaoPendente;
    const pendentes = distribuicaoPendente ? this.itensPendentesDistribuicao() : [];
    const motivoBloqueio = excedentePendente
      ? "Pague a diferença do excedente antes de concluir o cadastro."
      : distribuicaoPendente
        ? `Distribua todos os itens contratados antes de concluir. Faltam: ${pendentes.map(p => `${p.restante} de ${p.nome}`).join(', ')}.`
        : '';

    const btn = (
      <Button
        type="primary"
        size="large"
        id='btnFinalizarEtapa'
        onClick={() => {
          if (bloqueado) {
            toast.warning(motivoBloqueio);
            return;
          }
          this.setState({ showModalFinalizar: true });
        }}
        loading={this.state.botaoFinalizar}
        disabled={this.state.botaoFinalizar || bloqueado}
        style={{
          backgroundColor: bloqueado ? '#cbd5e1' : primaryColor,
          borderColor: bloqueado ? '#cbd5e1' : primaryColor,
          color: bloqueado ? '#64748b' : '#fff',
          borderRadius: '6px',
          fontWeight: 'bold',
          height: '44px',
          paddingLeft: 28,
          paddingRight: 28,
          boxShadow: bloqueado ? 'none' : '0 4px 14px rgba(211, 47, 47, 0.3)',
          cursor: bloqueado ? 'not-allowed' : 'pointer'
        }}
      >
        Concluir Cadastro
      </Button>
    );

    return (
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>
        {bloqueado ? (
          <Tooltip title={motivoBloqueio}>
            <span>{btn}</span>
          </Tooltip>
        ) : btn}
      </div>
    );
  }

  render() {
    if (this.props.usuario_a.tipo === 'formando') {
      return <Redirect to='/' />;
    }

    const primaryColor = '#d32f2f'; // Company Red
    const secondaryColor = '#212121'; // Company Black

    // Custom Button Styles
    const primaryBtnStyle = { backgroundColor: primaryColor, borderColor: primaryColor, borderRadius: '6px', fontWeight: 500 };
    // const dangerBtnStyle = { backgroundColor: '#fff', borderColor: primaryColor, color: primaryColor, borderRadius: '6px', fontWeight: 500 };

    // Modal Finalizar Etapa
    const modalFinalizar = (
      <Modal
        title={<span style={{ fontWeight: 'bold' }}>Finalizar Etapa</span>}
        visible={this.state.showModalFinalizar}
        onCancel={() => this.setState({ showModalFinalizar: false })}
        footer={[
          <Button key="back" onClick={() => this.setState({ showModalFinalizar: false })} style={{ borderRadius: '6px' }}>
            Cancelar
          </Button>,
          <Button key="submit" type="primary" danger onClick={this.finalizar.bind(this)} loading={this.state.botaoFinalizar} style={{ borderRadius: '6px', backgroundColor: primaryColor, borderColor: primaryColor }}>
            Confirmar
          </Button>
        ]}
        centered
      >
        <div style={{ textAlign: 'center', padding: '20px 0' }}>
          <TeamOutlined style={{ fontSize: 48, color: primaryColor, marginBottom: 16 }} />
          <p style={{ fontSize: '16px' }}>
            Confirme se todas as pessoas que personalizarão o convite
            (formandos, homenageados e professores) foram cadastradas e
            possuem e-mails válidos antes de finalizar essa etapa!
          </p>
        </div>
      </Modal>
    );

    // Modal Upload
    const modalUpload = (
      <Modal
        title={<span style={{ fontWeight: 'bold' }}>Cadastro via Planilha</span>}
        visible={this.state.showModalUpload}
        onCancel={() => this.setState({ showModalUpload: false })}
        footer={[
          <Button key="back" onClick={() => this.setState({ showModalUpload: false })} style={{ borderRadius: '6px' }}>
            Cancelar
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={this.carregarListaFormandos.bind(this)}
            loading={this.state.botaoCadastrarFormandosPorPlanilha}
            style={{ ...primaryBtnStyle }}
          >
            Enviar Dados
          </Button>
        ]}
        centered
        width={600}
      >
        <Alert
          message="Instruções Importantes"
          description={
            <div>
              <p>
                Para importar seus formandos, utilize nossa planilha modelo.
                <a href={`${process.env.PUBLIC_URL}/planilha-modelo.xlsx`} download='planilha-modelo.xlsx' style={{ color: primaryColor, fontWeight: 'bold', marginLeft: 5 }}>
                  <DownloadOutlined /> Baixar Modelo
                </a>
              </p>
              <ul style={{ paddingLeft: 20, marginTop: 10, color: '#555' }}>
                <li>Todos os campos são obrigatórios.</li>
                <li>Cada formando deve ocupar apenas uma linha.</li>
                <li>Valide os CPFs antes de enviar.</li>
              </ul>
            </div>
          }
          type="info"
          showIcon
          style={{ marginBottom: 24, borderRadius: '8px', border: '1px solid #e3f2fd', backgroundColor: '#e3f2fd' }}
        />

        <div style={{ marginBottom: 20 }}>
          <label style={{ fontWeight: 500, display: 'block', marginBottom: 8 }}>Curso / Turma <span style={{ color: primaryColor }}>*</span></label>
          <Select
            placeholder="Selecione o curso de destino"
            style={{ width: '100%' }}
            size="large"
            value={this.state.cursoSelecionadoPlanilha && this.state.cursoSelecionadoPlanilha.value}
            onChange={(val, opt) => this.handleChangeCursoSelecionadoPlanilha(opt)}
            options={this.state.turmasSelect}
          />
        </div>

        <div style={{ marginBottom: 15 }}>
          <label style={{ fontWeight: 500, display: 'block', marginBottom: 8 }}>Arquivo Excel <span style={{ color: primaryColor }}>*</span></label>

          <div style={{ display: 'flex', gap: 10 }}>
            <Input
              disabled
              value={this.state.fileName || ''}
              placeholder="Nenhum arquivo selecionado"
              style={{ flex: 1 }}
            />
            <Button
              icon={<UploadOutlined />}
              onClick={() => document.getElementById('upload').click()}
            >
              Selecionar
            </Button>
          </div>

          <input
            type='file'
            id='upload'
            accept='.xlsx,.xls'
            style={{ display: 'none' }}
            onChange={(e) => {
              this.handleFileChange(e);
              if (e.target.files && e.target.files[0]) {
                this.setState({ fileName: e.target.files[0].name });
              }
            }}
          />
          <input type='hidden' id='fakeInput' />
        </div>
      </Modal>
    );

    // Modal Formando (Adicionar/Editar)
    const modalFormando = (
      <Modal
        title={<span style={{ fontWeight: 'bold' }}>{this.state.operacao === 'editar' ? 'Editar Formando' : 'Novo Formando'}</span>}
        visible={this.state.showModalFormando}
        onCancel={this.resetar.bind(this)}
        footer={[
          <Button key="back" onClick={this.resetar.bind(this)} style={{ borderRadius: '6px' }}>
            Cancelar
          </Button>,
          <Button key="submit" type="primary" onClick={this.salvar.bind(this)} style={{ borderRadius: '6px', backgroundColor: primaryColor, borderColor: primaryColor }}>
            Salvar
          </Button>
        ]}
        centered
        width={700}
      >
        <Form layout="vertical">
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item label={<span style={{ fontWeight: 500 }}>Nome Completo</span>} required>
                <Input
                  name="nome"
                  value={this.state.formando.nome}
                  className='form-control'
                  onChange={(e) => this.handleChangeFormando(e)}
                  placeholder="Ex: João da Silva"
                  size="large"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label={<span style={{ fontWeight: 500 }}>E-mail</span>} required>
                <Input
                  name="email"
                  type="email"
                  value={this.state.formando.email}
                  className='form-control'
                  onChange={(e) => this.handleChangeFormando(e)}
                  placeholder="email@exemplo.com"
                  size="large"
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label={<span style={{ fontWeight: 500 }}>CPF</span>} required>
                <InputMask
                  mask="999.999.999-99"
                  value={this.state.formando.documento}
                  onChange={(e) => this.handleChangeFormando(e)}
                  className="ant-input ant-input-lg"
                  name="documento"
                  placeholder="000.000.000-00"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label={<span style={{ fontWeight: 500 }}>Data de Nascimento</span>} required>
                <Input
                  type="date"
                  name="dataNascimento"
                  value={this.state.formando.dataNascimento}
                  onChange={(e) => this.handleChangeFormando(e)}
                  size="large"
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label={<span style={{ fontWeight: 500 }}>Celular</span>} required>
                <InputMask
                  mask="(99) 99999-9999"
                  value={this.state.formando.celular}
                  name='celular'
                  onChange={(e) => this.handleChangeFormando(e)}
                  className="ant-input ant-input-lg"
                  placeholder="(00) 00000-0000"
                />
              </Form.Item>
            </Col>
          </Row>

          {this.state.turmasSelect.length > 0 && (
            <Form.Item label={<span style={{ fontWeight: 500 }}>Curso</span>} required>
              <Select
                placeholder='Selecione a turma'
                value={this.state.formando.turma && this.state.formando.turma.value ? this.state.formando.turma.value : this.state.formando.turma}
                onChange={(val, opt) => this.handleChangeCurso(opt)}
                options={this.state.turmasSelect}
                size="large"
              />
            </Form.Item>
          )}
          <Form.Item style={{ marginBottom: 0 }}>
            <div style={{ padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '6px', display: 'inline-flex', alignItems: 'center' }}>
              <Switch
                checked={this.state.formando.membroComissao}
                onChange={this.handleChangeMembroComissao.bind(this)}
                style={{ backgroundColor: this.state.formando.membroComissao ? primaryColor : undefined }}
              />
              <span style={{ marginLeft: 10, fontWeight: 500 }}>Membro da Comissão de Formatura</span>
            </div>
          </Form.Item>
        </Form>
      </Modal>
    );

    // Modal Notificacao Sucesso
    const modalNotificacao = (
      <Modal
        visible={this.state.showModalNotificacao !== false}
        onCancel={() => this.setState({ showModalNotificacao: false })}
        footer={null}
        centered
        width={400}
        bodyStyle={{ textAlign: 'center', padding: 40 }}
      >
        <div style={{ backgroundColor: '#e8f5e9', width: 80, height: 80, borderRadius: '50%', margin: '0 auto 20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <CheckOutlined style={{ fontSize: 40, color: '#4caf50' }} />
        </div>
        <h2 style={{ fontSize: 24, fontWeight: 'bold' }}>Sucesso!</h2>
        <p style={{ color: '#757575', fontSize: 16 }}>Cadastro de formandos finalizado com êxito.</p>
        <Button type="primary" onClick={() => this.setState({ showModalNotificacao: false })} style={{ ...primaryBtnStyle, marginTop: 10, width: '100%' }}>
          Continuar
        </Button>
      </Modal>
    );

    // Modal Info Curso
    const modalCursoNaoCadastrado = (
      <Modal
        visible={this.state.showModalCursoNaoCadastrado}
        closable={false}
        footer={null}
        centered
      >
        <div style={{ textAlign: 'center', padding: 20 }}>
          <div style={{ backgroundColor: '#fff3e0', width: 80, height: 80, borderRadius: '50%', margin: '0 auto 20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <TeamOutlined style={{ fontSize: 40, color: '#ff9800' }} />
          </div>
          <h2 style={{ fontWeight: 'bold' }}>Atenção Necessária</h2>
          <p style={{ color: '#757575' }}>Não conseguimos encontrar o seu curso cadastrado. Por favor, entre em contato com seu atendente.</p>
          <Button type="primary" href="./" style={{ marginTop: 20, backgroundColor: secondaryColor, borderColor: secondaryColor }}>Voltar para Início</Button>
        </div>
      </Modal>
    );

    // Modal Turmas List
    const modalTurmas = (
      <Modal
        title="Turmas Cadastradas"
        visible={this.state.showModalTurmas}
        onCancel={() => this.setState({ showModalTurmas: false })}
        footer={null}
        centered
      >
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
          {this.state.turmasSelect.map((curso, i) => (
            <Tag
              key={i}
              color="red"
              style={{ padding: '8px 16px', fontSize: 14, borderRadius: '20px', backgroundColor: '#ffebee', color: '#d32f2f', border: '1px solid #ffcdd2' }}
            >
              <span style={{ fontWeight: 'bold' }}>{curso.label}</span>
              <span style={{ marginLeft: 8, opacity: 0.8 }}>
                ({this.state.formandos.filter((formando) => formando.curso === curso.label).length})
              </span>
            </Tag>
          ))}
        </div>
      </Modal>
    );

    return (
      <div id='divContent' style={{ minHeight: '100vh', padding: '24px', backgroundColor: '#f0f2f5' }}>

        {/* Page Header Area */}
        <div style={{ marginBottom: 16 }}>
          <h1 style={{ fontSize: '22px', color: '#1a1a1a', marginBottom: '2px', fontWeight: 700 }}>Gerenciamento de Formandos</h1>
          <p style={{ color: '#757575', margin: 0, fontSize: 13 }}>Gerencie as informações da turma, adicione formandos e controle acessos.</p>
        </div>

        <ConfirmationModal
          ref='modal'
          confirmButtonStyle='btn-danger'
          title='Excluir Formando'
          confirmButton='Excluir'
          body='Tem certeza que deseja remover este formando da lista? Esta ação não pode ser desfeita.'
          onConfirm={this.deletar.bind(this)}
        />

        {this._renderBarraIndicadores()}

        <Card
          bordered={false}
          bodyStyle={{ padding: '20px' }}
          style={{ borderRadius: '12px', boxShadow: '0 4px 20px rgba(0, 0, 0, 0.05)' }}
        >
          {this.props.contrato.cadastrouFormandos === 0 && (
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16 }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <h3 style={{ margin: 0, fontWeight: 600, color: '#212121', fontSize: 18 }}>Lista de Formandos</h3>
                <span style={{ marginLeft: 12, backgroundColor: '#f5f5f5', padding: '4px 12px', borderRadius: '20px', fontSize: '12px', color: '#757575', fontWeight: 600 }}>
                  Total: {this.state.formandos.length}
                </span>
              </div>

              <div style={{ display: 'flex', gap: 12 }}>
                <Button
                  id='formandoPlanilha'
                  icon={<UploadOutlined />}
                  onClick={() => this.setState({ showModalUpload: true })}
                  style={{ borderRadius: '6px', borderColor: '#f3c2c2', color: primaryColor, fontWeight: 500 }}
                >
                  Importar Planilha
                </Button>
                <Button
                  id='formandoManual'
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() => this.setState({ showModalFormando: true })}
                  style={{ ...primaryBtnStyle }}
                >
                  Novo Formando
                </Button>
              </div>
            </div>
          )}

          <TabelaFormandos
            data={this.state.formandos}
            cadastrouFormandos={this.props.contrato.cadastrouFormandos}
            isAdmin={sessionStorage.getItem("alphaAdmin") === "true"}
            editarFormando={(formando) => this.handleClickEditar(formando)}
            excluirFormando={(id) => this.handleClickDelete(id)}
            reenviarEmail={(formando) => this.handleClickReenviarEmail(formando)}
            produtosRateio={this.ehRateioAtivo() ? this.getResumoRateio().porItem : []}
            valorRateioInput={(fid, iid) => this.valorRateioInput(fid, iid)}
            onChangeRateio={this.handleChangeRateio}
            onBlurRateio={this.handleBlurRateio}
            rateioBloqueado={this.rateioBloqueado()}
          />

          {this._renderResumoRateio()}

          {this._renderBotaoConcluir()}
        </Card>

        {this._renderModalPagamentoDiferenca()}

        {modalFinalizar}
        {modalUpload}
        {modalFormando}
        {modalNotificacao}
        {modalCursoNaoCadastrado}
        {modalTurmas}

        <Joyride
          continuous={true}
          run={this.state.run}
          scrollToFirstStep={true}
          showProgress={true}
          showSkipButton={true}
          steps={this.state.steps}
          styles={{
            options: {
              zIndex: 10000,
            },
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    usuario_a: state.usuario.autenticado,
    contrato: state.contrato.especifico,
    formandos: state.formando.todos,
    formandosComItens: state.formando.todos,
    carregando: state.formando.carregando,
    turmas: state.turmas.turmas,
  };
};

export default connect(mapStateToProps, {
  cadastrarAcao,
  adicionarFormandoECriarUsuario,
  consultarTurmas,
  editarCamposContrato,
  deletarFormando,
  adicionarFormando,
  editarFormando,
  editarFormandoEUsuario,
  obterFormandosPeloContrato,
  obterContratoPeloUsuario,
  adicionarItemFormando,
  removerItemFormando,
})(Formandos);
